import {rpAppLink} from "@pg-mono/rp-routes";

import {buildFriendlyPromotionSlug} from "./build_friendly_promotion_slug";
import {PromotionType} from "./PromotionType";

export interface IRegionPromotionLinkStats {
    promotions_count_promotions: number;
    promotions_count_open_days: number;
    promotions_count_discounts: number;
    promotions_count_last_minutes: number;
    promotions_count_presales: number;
    promotions_count_total: number;
}

export const getRegionPromotionLink = (
    regionSlug: string | undefined,
    regionParentSlug: string | undefined,
    stats: IRegionPromotionLinkStats | null | undefined
): string | null => {
    if (!regionSlug || !stats) return null;

    const buildLink = (type?: PromotionType) =>
        rpAppLink.promotions.listFriendly({
            friendlySlug: buildFriendlyPromotionSlug({region: regionSlug, regionParentSlug, type})
        });

    const typeOrder = [
        {count: stats.promotions_count_promotions, type: PromotionType.PROMOTION},
        {count: stats.promotions_count_open_days, type: PromotionType.OPEN_DAYS},
        {count: stats.promotions_count_discounts, type: PromotionType.DISCOUNT},
        {count: stats.promotions_count_last_minutes, type: PromotionType.LAST_MINUTE},
        {count: stats.promotions_count_presales, type: PromotionType.PRESALE}
    ] as const;

    for (const entry of typeOrder) {
        if (entry.count > 0) return buildLink(entry.type);
    }

    // API does not expose promotions_count_no_contribution — infer it from total minus all known types
    const promotionsCountNoContribution =
        stats.promotions_count_total -
        stats.promotions_count_promotions -
        stats.promotions_count_open_days -
        stats.promotions_count_discounts -
        stats.promotions_count_last_minutes -
        stats.promotions_count_presales;

    if (promotionsCountNoContribution > 0) {
        return buildLink(PromotionType.NO_CONTRIBUTION);
    }

    if (stats.promotions_count_total > 0) {
        return buildLink();
    }

    return null;
};
import {rpAppLink} from "@pg-mono/rp-routes";

import {buildFriendlyPromotionSlug} from "./build_friendly_promotion_slug";
import {PromotionType} from "./PromotionType";

export interface IRegionPromotionLinkStats {
    promotions_count_promotions: number;
    promotions_count_open_days: number;
    promotions_count_discounts: number;
    promotions_count_last_minutes: number;
    promotions_count_presales: number;
    promotions_count_total: number;
}

export const getRegionPromotionLink = (
    regionSlug: string | undefined,
    regionParentSlug: string | undefined,
    stats: IRegionPromotionLinkStats | null | undefined
): string | null => {
    if (!regionSlug || !stats) return null;

    const buildLink = (type?: PromotionType) =>
        rpAppLink.promotions.listFriendly({
            friendlySlug: buildFriendlyPromotionSlug({region: regionSlug, regionParentSlug, type})
        });

    const typeOrder = [
        {count: stats.promotions_count_promotions, type: PromotionType.PROMOTION},
        {count: stats.promotions_count_open_days, type: PromotionType.OPEN_DAYS},
        {count: stats.promotions_count_discounts, type: PromotionType.DISCOUNT},
        {count: stats.promotions_count_last_minutes, type: PromotionType.LAST_MINUTE},
        {count: stats.promotions_count_presales, type: PromotionType.PRESALE}
    ] as const;

    for (const entry of typeOrder) {
        if (entry.count > 0) return buildLink(entry.type);
    }

    // API does not expose promotions_count_no_contribution — infer it from total minus all known types
    const promotionsCountNoContribution =
        stats.promotions_count_total -
        stats.promotions_count_promotions -
        stats.promotions_count_open_days -
        stats.promotions_count_discounts -
        stats.promotions_count_last_minutes -
        stats.promotions_count_presales;

    if (promotionsCountNoContribution > 0) {
        return buildLink(PromotionType.NO_CONTRIBUTION);
    }

    if (stats.promotions_count_total > 0) {
        return buildLink();
    }

    return null;
};
